import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom'
import { Button, Container, Row, Col, Table, InputGroup, Input, InputGroupAddon, Form } from 'reactstrap';
import Pagination from "react-js-pagination";
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import { isUserAllowedToAddBrands } from '../../utils/CommonUtils';
import { loadBrands, createBrand, clearBrand, clearRestaurants, loadNotifications } from '../../actions/index';
import {
    DEFAULT_BRANDS_PAGE_SIZE,
    DEFAULT_PAGING_RANGE,
} from '../../utils/Constants';
import CustomTable from "../common/CustomTable";
import SearchButton from '../common/SearchButton';

class BrandsScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPageNumber: 1,
            advancedSearch: false,
            searchQuery: {
                brandName: '',
                managerName: '',
                managerEmail: ''
            }
        }

        this.createBrand = this.createBrand.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.changeState = this.changeState.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.search = this.search.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
    }

    componentWillMount() {
        this.props.loadBrands();

        // Clear the global (redux) state for the selected brand and its restaurants here
        // instead in the componentWillUnmount of the BrandScreen
        // because the brand is needed in the restaurant related screens after that
        // and if we clear it upon unomunting it cannot be used in the restaurant screens.
        // So clear it here.
        this.props.clearBrand();
        this.props.clearRestaurants();
    }

    changeState({ target }) {
        this.setState({
            searchQuery: {
                ...this.state.searchQuery,
                [target.name]: target.value,
            }
        });
    }


    search() {
        // new search should always start from page 1
        this.props.loadBrands(1, this.state.searchQuery);

        this.setState({
            currentPageNumber: 1
        });
    }

    clearSearch() {
        //new search should always start from page 1
        this.setState({
            searchQuery: {
                brandName: '',
                managerName: '',
                managerEmail: ''
            },
            currentPageNumber: 1
        });

        this.props.loadBrands();
    }

    toggleSearch() {
        // console.log('toggleSearch');
        // // toggling the search should reset the search query
        this.setState({
            advancedSearch: !this.state.advancedSearch,
            searchQuery: {
                brandName: '',
                managerName: '',
                managerEmail: ''
            },
            currentPageNumber: 1
        });

        this.props.loadBrands();
    }

    keyPress(event) {
        if (event.keyCode === 13) { // this is Enter
            this.search();
        }
    }

    renderSimpleSearch() {
        const { flexEnd, inputGroupSearch, inputSearch, paddingLeftRight, rowMarginTop, simpleSearchPipe,
            inputGroupAddon, cursorPointer } = styles;
        const { brandName } = this.state.searchQuery;

        return (
            <div>
                <Row>
                    <Col xs="auto" sm={10} >
                        <Row>
                            <Col xs={4} style={paddingLeftRight}>
                                <InputGroup style={inputGroupSearch}>
                                    <Input
                                        type="text" name="brandName" id="brandName" placeholder={i18n.t('screens:brandsScreen.brandName')}
                                        value={brandName}
                                        onChange={this.changeState}
                                        onKeyDown={this.keyPress}
                                        style={inputSearch} />
                                    <InputGroupAddon addonType="append" style={inputGroupAddon}>
                                        <div onClick={this.search} style={cursorPointer} ><MaterialIcon icon="search" color="#0288D1" size={28} /></div>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={2} style={flexEnd}>
                        <div>{this.renderAddBrand()}</div>
                    </Col>
                </Row>
                <Row style={rowMarginTop}>
                    <Col xs={10}>
                        <Row>
                            <Col xs={4} style={flexEnd}>
                                <Button color="link" onClick={this.clearSearch}>{i18n.t('common:searchForms.clear')}</Button>
                                <span style={simpleSearchPipe}>|</span>
                                <Button color="link" onClick={this.toggleSearch}>{i18n.t('common:searchForms.advancedSearch')}</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    renderAdvancedSearch() {
        const { flexEnd, paddingLeftRight, rowMarginTop, advancedSearchPipe } = styles;
        const { brandName, managerName, managerEmail } = this.state.searchQuery;

        return (
            <div>
                <Row>
                    <Col xs="auto" sm={10} >
                        <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                            <Row>
                                <Col md={2} style={paddingLeftRight}>
                                    <Input type="text" name="brandName" id="brandName" placeholder={i18n.t('screens:brandsScreen.brandName')} value={brandName} onChange={this.changeState} />
                                </Col>
                                <Col md={2} style={paddingLeftRight}>
                                    <Input type="text" name="managerName" id="managerName" placeholder={i18n.t('screens:brandsScreen.managerName')} value={managerName} onChange={this.changeState} />
                                </Col>
                                <Col md={3} style={paddingLeftRight}>
                                    <Input type="text" name="managerEmail" id="managerEmail" placeholder={i18n.t('screens:brandsScreen.managerEmail')} value={managerEmail} onChange={this.changeState} />
                                </Col>
                                <Col md={2}>
                                    <SearchButton search={this.search.bind(this)} />
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    <Col xs={2} style={flexEnd}>
                        <div>{this.renderAddBrand()}</div>
                    </Col>
                </Row>
                <Row style={rowMarginTop}>
                    <Col xs={7} style={Object.assign({ marginLeft: 55 }, flexEnd)}>
                        <Button color="link" onClick={this.clearSearch}>{i18n.t('common:searchForms.clear')}</Button>
                        <span style={advancedSearchPipe}>|</span>
                        <Button color="link" onClick={this.toggleSearch}>{i18n.t('common:searchForms.simpleSearch')}</Button>
                    </Col>
                </Row>
            </div>
        );
    }

    createBrand() {
        this.props.createBrand();
    }

    renderHeading() {
        const { screenHeading } = styles;

        return (
            <Col sm={1} style={screenHeading}>
                <div><MaterialIcon icon="local_activity" color="#0288d1" size={22} />&nbsp;
                {i18n.t('screens:restaurantsMainContainer.brands')}</div>
            </Col>
        );
    }

    renderAddBrand() {
        const { flexEnd } = styles;
        const userAllowedToAddBrands = isUserAllowedToAddBrands(this.props.currentlyLoggedInUser);

        if (userAllowedToAddBrands) {
            return (
                <Col style={flexEnd}>
                    <Button color="primary" onClick={this.createBrand}>
                        <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.addBrand')}
                    </Button>
                </Col>
            );
        } else {
            return (
                <span></span>
            );
        }
    }

    renderBrandsTable() {
        const { flexEnd, emailOverflow } = styles;

        return (
            <Col style={flexEnd}>
                <Table responsive hover>
                    <thead>
                        <tr className="d-flex">
                            <th className="col-2">{i18n.t('common:form.name')}</th>
                            <th className="col-3">{i18n.t('screens:menuConfigScreen.category')}</th>
                            <th className="col-2">{i18n.t('screens:brandScreen.manager')}</th>
                            <th className="col-2">{i18n.t('common:form.phone')}</th>
                            <th className="col-2" style={emailOverflow} >{i18n.t('common:form.email')}</th>
                            <th className="col-1">{i18n.t('screens:adminsScreen.lastActiveTime')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderBrandsTableRows()}
                    </tbody>
                </Table>
            </Col>
        );
    }

    renderBrandsTableRows() {
        const { emailOverflow } = styles;
        if (this.props.brands.content) {
            return this.props.brands.content.map(brand => {

                let key = { key: brand.chainId };

                const passPropsToBrandScreen = {
                    pathname: `/brand/${brand.chainId}`,
                    state: {
                        pathname: this.props.location.pathname,
                        title: 'Brands'
                    }
                }

                return (
                    <tr {...key} className="d-flex">
                        <td className="col-2" style={emailOverflow}>
                            <NavLink
                                id={brand.chainId}
                                tag={Link}
                                to={passPropsToBrandScreen}
                            >{brand.chainName}
                            </NavLink>
                        </td>
                        <td className="col-3" style={emailOverflow}>{brand.categories}</td>
                        <td className="col-2" style={emailOverflow}>{brand.managerName}</td>
                        <td className="col-2" style={emailOverflow}>{brand.managerPhone}</td>
                        <td className="col-2" style={emailOverflow}>{brand.managerEmail}</td>
                        <td className="col-1" style={emailOverflow}>{brand.lastActiveTime}</td>
                    </tr>
                );
            });
        }
    }

    handlePageChange(pageNumber) {
        this.setState({
            currentPageNumber: pageNumber
        });
        this.props.loadBrands(pageNumber, this.state.searchQuery);
    }

    render() {
        const { containerStyle, flexEnd } = styles;

        return (
            <Container fluid style={containerStyle}>
                {!this.state.advancedSearch ? this.renderAdvancedSearch() : this.renderSimpleSearch()}
                <Row>
                    {this.renderHeading()}
                </Row>
                {
                    this.props.brands.content !== undefined ?
                        <CustomTable
                            styles={styles}
                            tableName='brandsTable'
                            tableData={this.props.brands.content}
                            location={this.props.location}
                        />
                        :
                        <Row></Row>
                }
                <Row>
                    <Col style={flexEnd}>
                        <Pagination
                            activePage={this.props.brands.number + 1}
                            itemsCountPerPage={DEFAULT_BRANDS_PAGE_SIZE}
                            totalItemsCount={this.props.brands.totalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }
}

const mapStateToProps = state => {

    return {
        currentlyLoggedInUser: state.user,
        brands: state.brands
    }
}

export default connect(mapStateToProps, { loadBrands, createBrand, clearBrand, clearRestaurants, loadNotifications })(BrandsScreen);

let styles = {
    containerStyle: {
        width: '96%',
        marginTop: 20
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0,
        paddingLeft: 0
    },
    rowMarginTop: {
        marginTop: 20
    },
    emailOverflow: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    screenHeading: {
        display: 'flex',
        alignSelf: 'flex-end',
        borderBottom: '1px solid rgb(222, 226, 230)',
        paddingLeft: 0,
        color: '#0288d1'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    inputGroupSearch: {
        border: '1px solid lightgray'
    },
    inputSearch: {
        border: 0
    },
    paddingLeftRight: {
        paddingLeft: 5,
        paddingRight: 5
    },
    rowMarginTop: {
        marginBottom: 20
    },
    advancedSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    simpleSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    inputGroupAddon: {
        marginTop: '10px'
    },
    cursorPointer: {
        cursor: 'pointer'
    }
}



// WEBPACK FOOTER //
// ./src/components/brands/BrandsScreen.js